/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для одного товара в каталоге
   */
  app.ItemView = app.View.extend({

    // Обработчики пользовательских событий
    events: {
      'click .fav-add': 'toggleInFavorites',
      'click .tab': 'toggleModifier',
      'click': 'toggleCheck',
      'click .link': 'saveChooseToSessionStorage',
    },
    access: null,
    tooltip_template: _.template($('#item-tooltip').text()),
    additionalOptions: [
      'qtyView',
      'mainWindow',
      'bodyView',
      'currency',
    ],
    FILE_ID_3D_MODEL: 7,

    run: function () {
      this.initDom();
      this.isProtected = this.$el.find('.protected-item').length > 0;
      this.isToggleWishProcess = false;
    },

    /**
     * Инициализация доставки товара.
     */
    initItemDelivery: function () {
      this.retailFeeMarkupCostTemplate = app.helpers.TemplateHelper.getTemplate('#retail-fee-markup-cost-template');
      this.lessMinQtyTitleTemplate = app.helpers.TemplateHelper.getTemplate('#less-min-qty-title-template');
      this.lessMinQtyWrapTemplate = app.helpers.TemplateHelper.getTemplate('#less-min-qty-title-wrap-template');
    },

    /**
     * Рендер наценки на сборку.
     * @param {Object} model - модель товара.
     */
    renderRetailFeeMarkupCost: function (model) {
      var retailFeeMarkup = model && model.get('retail_fee_markup'),
        html = '';
      if (retailFeeMarkup) {
        html += this.retailFeeMarkupCostTemplate({
          retailFeeMarkup: retailFeeMarkup,
          grapheme: this.currency.sign,
        });
      }
      this.$('.js-retail-fee-markup-cost').html(html);
    },

    /**
     * Сохраняет идентификатор товара в хранилище сессии при переходе на страницу товара по ссылке.
     */
    saveChooseToSessionStorage: function () {
      var fullPath = location.origin + location.pathname;
      var storageKey = app.SESSION_CHOOSED_ITEM_ID_PREFIX + fullPath;
      if (typeof this.model.get === 'function') {
        app.helpers.StorageHelper.SS.set(storageKey, this.model.get('id'));
      }
    },

    /**
     * Добавление вью со звездами рейтинга, если у айтема есть mean_rating
     * @item передаем из cart-item-view, т.к. там другая модель
     */
    addRating: function (item) {
      if (app.locale !== app.LOCALES.ru) {
        return;
      }
      var rating,
        counter;

      if (item && item.mean_rating) {
        rating = item.mean_rating;
        counter = item.comments_count;
      } else {
        rating = this.model.get('mean_rating');
        counter = this.model.get('comments_count');
      }

      if (rating) {
        this.childViews.starRating = new app.StarRatingView({
          el: this.$('.js-product-rating').removeClass('not_display'),
          rating: rating,
          counter: counter,
          onRatingClick: this.gotoProductReview.bind(this),
        });
      }
    },

    /**
     * Переход по клику количества комментариев в каталоге на страницу товара с открытыми отзывами
     */
    gotoProductReview: function () {
      var sid = this.model.get('sid') || this.model.get('item_sid');
      app.helpers.RedirectHelper.locationAssign('/' + sid + '#review');
    },

    initDom: function () {
      this.access = {
        canCreateWishItem: false,
        canDestroyWishItem: false
      };
      this.wtfId = this.wtfId || this.$('[data-cart-input]').attr('data-cart-input');
      this.favWtfId = this.favWtfId || this.$('[data-wtf-id]').data('wtf-id');
      this.favBtn = this.$('.fav-add');
      this.jsonItems = this.$('.modifiers-json');
      this.checkbox = this.$('input[type=checkbox]');
      this.link = this.$('.catalog__item-link').attr('href');

      // для случая корзины
      if (this.qtyView === 'CartItemQtyView') {
        this.qtyView = new app[this.qtyView]({
          el: $(this.el),
          model: app.cart.findWhere({id: parseInt(this.wtfId, 10)})
        });
      } else if (this.jsonItems.text()) {
        this.modifiers = new app.Items();
        this.modifiers.reset(JSON.parse(this.jsonItems.text()));
        this.qtyView = new app[this.qtyView]({
          el: $(this.el),
          model: this.modifiers.first(),
          isNotCart: true
        });
      }
      this.setTimer();

      // обновляем статус для товаров, добавленных в избранное
      if (app.wish.get(this.favWtfId) !== undefined) {
        this.access.canDestroyWishItem = true;
        this.wishItem = app.wish.get(this.favWtfId);
        if (this.favBtn.hasClass('fav-big')) {
          this.favBtn.toggleClass('added with-icon_fav-not-active with-icon_fav-active');
        } else {
          this.favBtn.toggleClass('with-icon_favs-grey added with-icon_favs-red ctl-hidden');
        }
      } else {
        this.access.canCreateWishItem = true;
      }
      // TODO Посмотреть почему не срабатывает стандартный remove у коллекции
      this.listenTo(app.wish, 'update', this.updateOnWish);
    },

    /**
     * Id товара
     * @return {number} id
     */
    getItemId: function () {
      return this.favWtfId;
    },

    /**
     * Обновление по событию после добавления или удаления из избранного
     */
    updateOnWish: function () {
      var id = this.getItemId();
      if (app.wish.get(id) !== undefined) {
        /*
         * Если модель есть в коллекции избранных, но представление товара не знает об этом.
         * Кейс возникает когда товар отображается на странице в двух и более местах.
         */
        if (this.wishItem === undefined) {
          this.wishItem = app.wish.get(id);
          this.access.canDestroyWishItem = true;
        }
        if (!this.favBtn.hasClass('added')) {
          if (this.favBtn.hasClass('fav-big')) {
            this.favBtn.removeClass('with-icon_fav-not-active').addClass('added with-icon_fav-active');
          } else {
            this.favBtn.removeClass('with-icon_favs-grey ctl-hidden').addClass('added with-icon_favs-red');
          }
        }
      } else {
        if (this.favBtn.hasClass('added')) {
          if (this.favBtn.hasClass('fav-big')) {
            this.favBtn.removeClass('added with-icon_fav-active').addClass('with-icon_fav-not-active');
          } else {
            this.favBtn.removeClass('added with-icon_favs-red').addClass('with-icon_favs-grey ctl-hidden');
          }
        }
      }
    },

    /**
     * Активация товара в общем списке.
     */
    activate: function () {
      if (this.checkbox.length) {
        this.$el.addClass('selected');
        this.checkbox.prop('checked', true);
        this.selected = true;
        Backbone.trigger('update-grid-buttons');
      }
    },

    /**
     * Деактивация товара в общем списке.
     */
    deactivate: function () {
      if (this.checkbox.length) {
        this.$el.removeClass('selected');
        this.checkbox.prop('checked', false);
        this.selected = false;
        Backbone.trigger('update-grid-buttons');
      }
    },

    /**
     * Обратный отсчет для спецпредложений.
     */
    setTimer: function () {
      var $time = this.$('time');
      var that = this;
      //Вызывается прерывание, чтобы при перерендеривании времени не показывалось NaN
      var timeoutRender = function () {
        $time.countdown(new Date($time.attr('data-date')), function (event) {
          that.$('.days', $time).html(event.strftime('%D'));
          that.$('.hours', $time).html(event.strftime('%H'));
          that.$('.minutes', $time).html(event.strftime('%M'));
          that.$('.seconds', $time).html(event.strftime('%S'));
        });
      };
      setTimeout(timeoutRender, 0);
    },

    /**
     * Добавляет или удаляет товар из избранного
     */
    toggleInFavorites: function () {
      var id = this.model.id;
      if (this.isToggleWishProcess) {
        return;
      }
      this.isToggleWishProcess = true;
      //Без авторизации - редирект
      if (!app.user.id) {
        app.helpers.CookieHelper.setCookie('wishesAfterLogin', [id], {
          domain: '.' + app.helpers.UrlHelper.getDomain(),
          path: '/',
          expires: 450,
        });
        this.redirectToAuth();
        return;
      }

      var self = this;
      if (app.wish.get(id) === undefined) {
        // если товара ещё нет в избранном
        if (this.access.canCreateWishItem) {
          this.wishItem = app.wish.create({
            item_id: id
          }, {
            wait: true,
            success: function () {
              self.access.canDestroyWishItem = true;
              self.isToggleWishProcess = false;
            },
            error: function () {
              self.isToggleWishProcess = false;
            },
            method: 'POST'
          });
        } else {
          self.isToggleWishProcess = false;
        }
      } else {
        // если товар есть в избранном
        if (this.access.canDestroyWishItem) {
          /*
           * Так как единственный достоверный метод узнать для двух одинаковых представлений на странице,
           * что товар в избранном - это запросить его наличие в коллекции то приходится
           * удалять товар из коллекции принудительно, перед тем, как удалить WishItem
           */
          var that = this;
          this.wishItem = app.wish.get(id);
          this.wishItem.destroy({
            url: this.wishItem.url + this.wishItem.get('item_id') + '/',
            wait: true,
            success: function () {
              self.access.canCreateWishItem = true;
              app.wish.remove(that.wishItem);
              that.trigger('removedFromWish', 1);
              self.isToggleWishProcess = false;
            },
            error: function () {
              self.isToggleWishProcess = false;
            }
          });
        }
      }
    },
    /**
     * Ставит или убирает чекбокс при клике на товар.
     *
     * @param e
     */
    toggleCheck: function (e) {
      var $target = $(e.target);
      if (
        $target.closest('.slider-range-min, .tab, .link, .countInput-fake, .flag, .ctl, .slider-amount-wrap ,[data-cart-link]').length === 0
        && !app.isMobile
      ) {
        e.stopPropagation();
        if (this.checkbox) {
          if ((this.checkbox.prop('checked') && !$target.is(this.checkbox)) || (!this.checkbox.prop('checked') && $target.is(this.checkbox))) {
            this.deactivate();
          } else {
            this.activate();
          }
        }
      }
    },
    /**
     * Файл '3D модель'
     * @returns {Object|undefined} Данные о файле с 3d моделью
     */
    get3dModelFile: function () {
      var itemsFiles;
      if (this.model instanceof app.CartItem) {
        itemsFiles = _.get(this.model.get('item'), 'files');
      } else {
        itemsFiles = this.model.get('files');
      }
      return _.find(itemsFiles, { type_id: this.FILE_ID_3D_MODEL });
    },
  });

  _.extend(app.ItemView.prototype, app.ItemInViewPortMixin);
})(jQuery);

}.call(window));